module.exports = "<p>\n  questionnaire works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/questionnaire/questionnaire.component.html
// module id = ../../../../../src/app/home/questionnaire/questionnaire.component.html
// module chunks = common